// import home from './views/home';
// import Page from './views/page';
// import ArchiveLanding from './views/ArchiveLanding';
// import LayoutB from './views/LayoutB';
// import LayoutC from './views/LayoutC';

const AppViews = {
  // ArchiveLanding,
  // LayoutB,
  // LayoutC,
  // Page,
  // home
};

export default AppViews;
